import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import queryString from 'query-string';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import ReactSelectMaterialUi from 'react-select-material-ui';
import { IconButton, Paper, Popover, TextField } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import MenuDrawerGroup from '../../components/MenuDrawerGroup';
import GroupTableGroup from '../organisms/GroupTableGroup';
import GroupEdit from '../organisms/GroupEdit';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import ExPaginationGroup from '../../components/molecules/ExPaginationGroup';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { getGroups, getGroupDetail } from '../../actions/Groups';
import { getShops } from '../../actions/Shop';
import { getAccounts } from '../../actions/Accounts';
import GroupRegisterButton from '../../components/atoms/GroupRegisterButton';
import GroupAddAdmin from '../organisms/GroupAddAdmin';
import shopApplyType from '../../constants/GochiKidConstant';

const drawerWidth = 240;

const styles = theme => ({
  root: {
    display: 'flex'
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  menuButton: {
    marginRight: 36
  },
  hide: {
    display: 'none'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap'
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1
    }
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    width: 'calc(100% - 240px)'
  },
  // end sidebar
  title: {
    color: '#000',
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 15
  },
  pageTitileDiv: {
    padding: 0,
    display: 'flex',
    alignItems: 'flex-end'
  },
  pageTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    paddingRight: 45
  },
  fs12: {
    fontSize: '12px !important'
  },
  textBold: {
    fontWeight: 'bold !important'
  },
  mainPaper: {
    position: 'relative',
    margin: '20px 0'
  },
  searchForm: {
    padding: '26px 26px 26px 26px',
    display: 'flex',
    alignItems: 'flex-end'
  },
  buttonSearch: {
    margin: '5px 5px',
    fontWeight: 'bold',
    paddingTop: 10
  },
  topButtonDiv: {
    padding: '10px 26px 10px 26px',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  buttonGroupLeft: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 'auto'
  },
  groupName: {
    marginLeft: '15px'
  },
  buttonGroupRight: {
    display: 'flex',
    marginLeft: 'auto'
  },
  bottomButtonDiv: {
    padding: '10px 26px 10px 0px',
    textAlign: 'right'
  },
  button: {
    margin: '5px 0px 5px 5px',
    minWidth: '140px',
    fontSize: '0.8rem'
  },
  textField: {
    marginLeft: '10px',
    padding: '0px 5px 0px 5px',
    width: '300px',
    zIndex: 5
  },
  textField200: {
    padding: '0px 0px 5px 0px',
    width: '200px'
  },
  textField120: {
    padding: '0px 0px 5px 0px',
    width: '120px'
  },
  tableTopDiv: {
    textAlign: 'right',
    // paddingBottom: '20px',
    display: 'flex',
    alignItems: 'flex-start'
  },
  flexRight: {
    marginLeft: 'auto'
  },
  formControl: {
    paddingLeft: 5,
    paddingRight: 5,
    width: 'auto'
  },
  subTitle: {
    fontWeight: '600',
    fontSize: 12,
    marginBottom: 10,
    color: '#000000'
  },
  buttonInfo: {
    backgroundColor: 'transparent',
    margin: '5px 14px 5px 9px',
    padding: '6px 0'
  },
  popoverContent: {
    marginTop: 4,
    pointerEvents: 'auto'
  },
  contentPopover: {
    padding: 16,
    fontSize: 14,
    width: 400
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      groups: state.groups.groups,
      totalCount: state.shops.totalCount,
      limit: state.shops.limit
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGroups,
          getGroupDetail,
          getShops,
          getAccounts
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openTable', 'updateOpenTable', false),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openEditConfirm', 'updateOpenEditConfirm', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('otherLanguages', 'setOtherLanguages', {}),
  withState('targetGroupId', 'setTargetGroupId', props => {
    return queryString.parse(props.location.search).groupId || 0;
  }),
  withState('groupId', 'setGroupId', 0),
  withState('groupName', 'setGroupName', ''),
  withState('countryCode', 'setCountryCode', ''),
  withState('zipCode', 'setZipCode', ''),
  withState('prefectureCode', 'setPrefectureCode', 0),
  withState('prefectures', 'setPrefectures', ''),
  withState('city', 'setCity', ''),
  withState('cityId', 'setCityId', ''),
  // withState('cityName', 'setCityName', ''),
  withState('address', 'setAddress', ''),
  withState('building', 'setBuilding', ''),
  withState('phone', 'setPhone', ''),
  withState('fax', 'setFax', ''),
  withState('groupContactName', 'setGroupContactName', ''),
  withState('department', 'setDepartment', ''),
  withState('directPhone', 'setDirectPhone', ''),
  withState('groupType', 'setGroupType', 'CHAIN_SHOP'),
  withState('groupTypeStr', 'setGroupTypeStr', 'チェーン店'),
  withState('depositManage', 'setDepositManage', 'NOT_MANAGE'),
  withState(
    'depositManageStr',
    'setDepositManageStr',
    'グループでは入金管理を登録しない'
  ),
  withState('bankName', 'setBankName', ''),
  withState('bankBranchName', 'setBankBranchName', ''),
  withState('bankAccountType', 'setBankAccountType', 'SAVINGS'),
  withState('bankAccountTypeStr', 'setBankAccountTypeStr', '普通預金'),
  withState('bankAccountNumber', 'setBankAccountNumber', ''),
  withState('bankAccountHolder', 'setBankAccountHolder', ''),
  withState('stripeUseSwitchable', 'setStripeUseSwitchable', true),
  withState('email', 'setEmail', ''),
  withState('createdAt', 'setCreatedAt', ''),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('groupIdentity', 'setGroupIdentity', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 20),
  withState('stripeAccount', 'setStripeAccount', false),
  withState('images', 'setImages', []),
  withState('description', 'setDescription', ''),
  withState('website', 'setWebsite', ''),
  withState('openGroupAdd', 'updateOpenGroupAdd', false),
  withState('openGroupAddConfirm', 'updateOpenGroupAddConfirm', false),
  withState('isUpdated', 'updateGroups', false),
  withState('shopId', 'setShopId', null),
  withState('shopName', 'setShopName', null),
  withState('filterParams', 'setFilterParams', {}),
  withState('hideRowsPerPage', 'setHideRowsPerPage', true),
  withState('groupDetail', 'setGroupDetail', {}),
  withState('anchorEl', 'setAnchorEl', null),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => event => {
      props.setRowsPerPage(event.target.value);
    },
    handleChangePage: props => async (event, page, limit, filterParams) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);

      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 20;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }

      const groupSearchKey = {
        groupId: props.groupId,
        limit: limit || limitNum,
        page,
        ...props.filterParams,
        ...filterParams
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      // if (!props.targetGroupId) {
      props.actions.getShops(groupSearchKey).then(shopData => {
        if (shopData.error === true && shopData.payload.status === 403) {
          sendLogin(props);
        }
        if (shopData.type === 'GET_SHOPS_SUCCESS') {
          props.updateOpenTable(true);
        } else {
          alert('失敗しました');
        }
        props.updateLoading(false);
        props.updateOpenProgress(false);
      });
      // }
    },
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.updateOpenProgress(true);
      this.props.updateLoading(true);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);
        // if (data.payload.role === 'SECRETARIAT') {
        //   await this.props.actions.getGroups();
        //   return;
        // }
        await this.props.actions
          .getGroupDetail(this.props.targetGroupId || data.payload.groupId)
          .then(groupData => {
            if (!this.props.targetGroupId) {
              this.props.setGroupId(groupData.payload.groupId);
              this.props.setGroupName(groupData.payload.groupName);
              this.props.setPhone(groupData.payload.phone);
              this.props.setGroupIdentity(
                groupData.payload.groupAccountStatus
                  ? groupData.payload.groupAccountStatus.identity
                  : ''
              );
              this.props.actions
                .getShops({
                  shopId: this.props.shopId,
                  shopName: this.props.shopName,
                  page: this.props.page,
                  limit: this.props.rowsPerPage
                })
                .then(shopData => {
                  this.props.checkSession(shopData);
                  if (shopData.type === 'GET_SHOPS_SUCCESS') {
                    this.props.updateOpenTable(true);
                  }
                  this.props.updateOpenProgress(false);
                  this.props.updateLoading(false);
                });
            }
          });
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    account,
    groups,
    totalCount,
    limit,
    checkSession,
    handleChangePage,
    handleRedirect,
    handleChangeRowsPerPage,
    updateOpenTable,
    targetGroupId,
    setTargetGroupId,
    groupId,
    setGroupId,
    groupName,
    setGroupName,
    countryCode,
    setCountryCode,
    zipCode,
    setZipCode,
    prefectureCode,
    setPrefectureCode,
    prefectures,
    setPrefectures,
    city,
    setCity,
    cityId,
    setCityId,
    // cityName,
    // setCityName,
    address,
    setAddress,
    building,
    setBuilding,
    phone,
    setPhone,
    email,
    setEmail,
    fax,
    setFax,
    groupContactName,
    setGroupContactName,
    department,
    setDepartment,
    directPhone,
    setDirectPhone,
    groupType,
    setGroupType,
    groupTypeStr,
    setGroupTypeStr,
    depositManage,
    setDepositManage,
    depositManageStr,
    setDepositManageStr,
    bankName,
    setBankName,
    bankBranchName,
    setBankBranchName,
    bankAccountType,
    setBankAccountType,
    bankAccountTypeStr,
    setBankAccountTypeStr,
    bankAccountNumber,
    setBankAccountNumber,
    bankAccountHolder,
    setBankAccountHolder,
    stripeUseSwitchable,
    setStripeUseSwitchable,
    createdAt,
    setCreatedAt,
    updatedAt,
    setUpdatedAt,
    openTable,
    openEditModal,
    updateOpenEditModal,
    openEditConfirm,
    updateOpenEditConfirm,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    groupIdentity,
    setGroupIdentity,
    page,
    setPage,
    stripeAccount,
    setStripeAccount,
    images,
    setImages,
    description,
    setDescription,
    setWebsite,
    website,
    openGroupAdd,
    updateOpenGroupAdd,
    openGroupAddConfirm,
    updateOpenGroupAddConfirm,
    isUpdated,
    updateGroups,
    shopId,
    setShopId,
    shopName,
    setShopName,
    filterParams,
    setFilterParams,
    setRowsPerPage,
    hideRowsPerPage,
    otherLanguages,
    setOtherLanguages,
    groupDetail,
    setGroupDetail,
    anchorEl,
    setAnchorEl
  }) => {
    const bankAccount = {
      bankName,
      bankBranchName,
      bankAccountType,
      bankAccountTypeStr,
      bankAccountNumber,
      bankAccountHolder
    };
    const groupAccountStatus = {
      stripeAccount
    };
    const detail = {
      groupId,
      groupName,
      countryCode,
      zipCode,
      prefectureCode,
      prefectures,
      city,
      cityId,
      // cityName,
      address,
      building,
      phone,
      fax,
      groupContactName,
      department,
      directPhone,
      groupType,
      groupTypeStr,
      depositManage,
      depositManageStr,
      bankAccount,
      stripeUseSwitchable,
      email,
      createdAt,
      updatedAt,
      groupAccountStatus,
      images,
      website,
      description,
      otherLanguages,
      groupDetail
    };
    const open = Boolean(anchorEl);
    const idPopover = open ? 'info-popover' : undefined;
    const isGroup = typeof account !== 'undefined' && account.role === 'GROUP';
    const isSecretariat =
      typeof account !== 'undefined' && account.role === 'SECRETARIAT';
    const gochiKidShopApplyType =
      typeof account !== 'undefined' && account.gochiKidShopApplyType;
    const roles = {
      isGroup,
      isSecretariat
    };

    const progress = {
      loading,
      updateLoading,
      openProgress,
      updateOpenProgress
    };

    const rowsPerPage = document.getElementById('rowsPerPage');
    let limitNum = 20;
    if (rowsPerPage) {
      limitNum = rowsPerPage.textContent;
    }

    const groupSearchKey = {
      groupId: targetGroupId,
      shopId,
      shopName,
      limit: limitNum,
      page
    };

    useEffect(() => {
      groupSearchKey.page = 1;
      setPage(1);
      updateOpenProgress(true);
      updateLoading(true);
      const getGroupData = async () => {
        if (!targetGroupId) {
          updateOpenTable(false);
          setGroupId(0);
          setGroupName('');
          setGroupIdentity(false);
        } else {
          await actions.getGroupDetail(targetGroupId).then(data => {
            checkSession(data);
            setGroupId(data.payload.groupId);
            setGroupName(data.payload.groupName);
            setGroupIdentity(data.payload.groupAccountStatus.identity);
            updateOpenProgress(false);
            updateLoading(false);
            actions.getShops(groupSearchKey).then(shopData => {
              if (shopData.type === 'GET_SHOPS_SUCCESS') {
                updateOpenTable(true);
              } else {
                alert('失敗しました');
              }
              updateOpenProgress(false);
              updateLoading(false);
            });
          });
        }
      };
      getGroupData();
    }, [targetGroupId]);

    useEffect(() => {
      actions.getGroups();
      updateGroups(false);
    }, [isUpdated]);

    const getGroupOptions = () => {
      const groupOptions = [];
      groups.forEach(group => {
        groupOptions.push({
          label: group.groupName,
          value: String(group.groupId)
        });
      });
      return groupOptions;
    };
    const getGroupIdOptions = () => {
      const groupIdOptions = [];
      groups.forEach(group => {
        groupIdOptions.push({
          label: group.groupId,
          value: String(group.groupId)
        });
      });
      return groupIdOptions;
    };

    const getGroup = async id => {
      await actions.getGroupDetail(id).then(detailData => {
        checkSession(detailData);
        setGroupId(detailData.payload.groupId);
        setGroupName(detailData.payload.groupName);
        setCountryCode(detailData.payload.countryCode);
        setZipCode(detailData.payload.zipCode);
        setPrefectureCode(detailData.payload.prefectureCode);
        setPrefectures(detailData.payload.prefectures);
        setCity(detailData.payload.city);
        setCityId(detailData.payload.cityId);
        // setCityName(detailData.payload.cityName);
        setAddress(detailData.payload.address);
        setBuilding(detailData.payload.building);
        setPhone(detailData.payload.phone);
        setFax(detailData.payload.fax);
        setGroupContactName(
          detailData.payload.groupContactName
            ? detailData.payload.groupContactName
            : ''
        );
        setDepartment(
          detailData.payload.department ? detailData.payload.department : ''
        );
        setDirectPhone(
          detailData.payload.directPhone ? detailData.payload.directPhone : ''
        );
        setGroupType(detailData.payload.groupType);
        setGroupTypeStr(detailData.payload.groupTypeStr);
        setDepositManage(detailData.payload.depositManage);
        setDepositManageStr(detailData.payload.depositManageStr);
        setBankName(detailData.payload.bankAccount.bankName);
        setBankBranchName(detailData.payload.bankAccount.bankBranchName);
        setBankAccountType(detailData.payload.bankAccount.bankAccountType);
        setBankAccountTypeStr(
          detailData.payload.bankAccount.bankAccountTypeStr
        );
        setBankAccountNumber(detailData.payload.bankAccount.bankAccountNumber);
        setBankAccountHolder(detailData.payload.bankAccount.bankAccountHolder);
        setStripeUseSwitchable(detailData.payload.stripeUseSwitchable);
        setEmail(detailData.payload.email);
        setCreatedAt(detailData.payload.createdAt);
        setUpdatedAt(detailData.payload.updatedAt);
        setStripeAccount(detailData.payload.groupAccountStatus.stripeAccount);
        setDescription(detailData.payload.description);
        setWebsite(detailData.payload.website);
        if (
          typeof detailData.payload.groupImages !== 'undefined' &&
          detailData.payload.groupImages !== null
        ) {
          setImages(detailData.payload.groupImages);
        }
        setOtherLanguages(detailData.payload.otherLanguages);
        setGroupDetail(detailData.payload.groupDetail);
      });
    };
    const editOpenAction = () => {
      updateLoading(true);
      updateOpenProgress(true);
      getGroup(groupId)
        .then(() => {
          updateOpenProgress(false);
          updateLoading(false);
          updateOpenEditModal(true);
        })
        .catch(() => {
          updateOpenProgress(false);
          updateLoading(false);
        });
    };
    const registerOpenAction = () => updateOpenGroupAdd(true);
    const groupCancelAction = () => updateOpenGroupAdd(false);
    const groupBackAction = () => updateOpenGroupAddConfirm(false);
    const searchAction = () => {
      updateOpenTable(true);
      const newFilterParams = {
        shopId: shopId || undefined,
        shopName: shopName || undefined
      };
      setFilterParams(newFilterParams);
      handleChangePage(null, 1, limitNum, newFilterParams);
    };

    const handleClickPopover = event => {
      setAnchorEl(event.currentTarget);
    };

    const handleClosePopover = () => {
      setAnchorEl(null);
    };

    return (
      <div className={classes.root}>
        <MenuDrawerGroup title="グループ店舗管理" />
        <main className={classes.content}>
          <div className={classes.toolbar} style={{ display: 'none' }} />
          <Typography variant="h6" noWrap className={classes.title}>
            グループ店舗管理
          </Typography>
          <div className={classes.pageTitileDiv}>
            <Typography color="textPrimary" className={classes.pageTitle}>
              {groupName}
            </Typography>
            <Typography
              color="textPrimary"
              className={[classes.fs12, classes.textBold]}
            >
              {phone}
            </Typography>
          </div>
          <Paper className={classes.mainPaper} elevation={1}>
            <div className={classes.searchForm}>
              <FormControl
                className={clsx(classes.margin, classes.formControl)}
                variant="outlined"
                size="small"
              >
                <FormLabel className={classes.subTitle}>店舗ID</FormLabel>
                <TextField
                  placeholder="例) 0123"
                  type="search"
                  className={classes.textField120}
                  variant="outlined"
                  size="small"
                  value={shopId}
                  onChange={e => {
                    setShopId(e.target.value);
                  }}
                />
              </FormControl>
              <FormControl
                className={clsx(classes.margin, classes.formControl)}
                variant="outlined"
                size="small"
              >
                <FormLabel className={classes.subTitle}>店舗名</FormLabel>
                <TextField
                  placeholder="例) Gigi 〇〇店"
                  type="search"
                  className={classes.textField200}
                  variant="outlined"
                  size="small"
                  value={shopName}
                  onChange={e => {
                    setShopName(e.target.value);
                  }}
                />
              </FormControl>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonSearch}
                onClick={searchAction}
              >
                検索
              </Button>
            </div>
          </Paper>
          <div className={classes.tableTopDiv}>
            <ExPaginationGroup
              count={
                totalCount % limit > 0
                  ? Math.floor(totalCount / limit) + 1
                  : Math.floor(totalCount / limit)
              }
              selectedPage={page}
              handleChangePage={handleChangePage}
              limit={limit}
              setLimit={setRowsPerPage}
              totalCount={totalCount}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              hideRowsPerPage={hideRowsPerPage}
            />
            <Button
              variant="contained"
              color="primary"
              disabled={
                !groupIdentity || gochiKidShopApplyType === shopApplyType.CITY
              }
              onClick={() => {
                handleRedirect('/group_shops_group');
              }}
              className={[classes.button, classes.flexRight]}
            >
              グループ店舗追加
            </Button>
            {gochiKidShopApplyType === shopApplyType.CITY && (
              <div>
                <IconButton
                  aria-describedby={idPopover}
                  className={classes.buttonInfo}
                  onClick={handleClickPopover}
                >
                  <InfoIcon color="primary" />
                </IconButton>
                <Popover
                  id={idPopover}
                  open={open}
                  anchorEl={anchorEl}
                  classes={{
                    paper: classes.popoverContent
                  }}
                  onClose={handleClosePopover}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                  }}
                >
                  <div className={classes.contentPopover}>
                    当グループアカウントでは、GOCHIプラットフォーム管理システムに登録されている店舗の住所（都道府県、市区町村）に基づいて、「こどもごちめし」をご利用いただける店舗が自動的に選ばれる設定となっております。
                    <br />
                    そのため、お客様ご自身で特定の店舗を追加することはできませんので、ご了承ください。
                  </div>
                </Popover>
              </div>
            )}
          </div>

          {1 === 0 && (
            <div className={classes.topButtonDiv}>
              <div className={classes.buttonGroupLeft}>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!groupId}
                  onClick={editOpenAction}
                  className={classes.button}
                >
                  グループ情報
                  <br />
                  編集
                </Button>
                {isGroup && (
                  <Typography
                    component="p"
                    variant="h6"
                    color="textSecondary"
                    className={classes.groupName}
                  >
                    {groupName}
                  </Typography>
                )}
                {isSecretariat && (targetGroupId || targetGroupId === 0) && (
                  <ReactSelectMaterialUi
                    required
                    label="グループ名"
                    className={classes.textField}
                    defaultValue={String(targetGroupId)}
                    value={String(targetGroupId)}
                    options={getGroupOptions()}
                    margin="normal"
                    onChange={v => {
                      setTargetGroupId(Number(v));
                    }}
                    SelectProps={{
                      isClearable: true,
                      msgNoOptionsMatchFilter:
                        '名前が部分一致するグループがありません'
                    }}
                  />
                )}
                {isSecretariat && (targetGroupId || targetGroupId === 0) && (
                  <ReactSelectMaterialUi
                    required
                    label="グループID"
                    className={classes.textField}
                    defaultValue={String(targetGroupId)}
                    value={String(targetGroupId)}
                    options={getGroupIdOptions()}
                    margin="normal"
                    onChange={v => {
                      setTargetGroupId(Number(v));
                    }}
                    SelectProps={{
                      isClearable: true,
                      msgNoOptionsMatchFilter:
                        '名前が部分一致するグループがありません'
                    }}
                  />
                )}
              </div>

              <div className={classes.buttonGroupRight}>
                {isSecretariat && (
                  <GroupRegisterButton onClickAction={registerOpenAction} />
                )}
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!groupIdentity}
                  onClick={() => {
                    handleRedirect('/group_shops');
                  }}
                  className={classes.button}
                >
                  グループ店舗
                  <br />
                  追加
                </Button>
              </div>
            </div>
          )}
          {openTable && (
            <Paper variant="outlined" square>
              <GroupTableGroup
                roles={roles}
                groupId={groupId}
                progress={progress}
                page={page}
                onChangePage={p =>
                  handleChangePage(p, rowsPerPage, filterParams)
                }
                handleChangePage={handleChangePage}
                selectedPage={page}
              />
            </Paper>
          )}
          <div className={classes.bottomButtonDiv}>
            <ExPaginationGroup
              count={
                totalCount % limit > 0
                  ? Math.floor(totalCount / limit) + 1
                  : Math.floor(totalCount / limit)
              }
              selectedPage={page}
              handleChangePage={handleChangePage}
              limit={limit}
              setLimit={setRowsPerPage}
              totalCount={totalCount}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              hideRowsPerPage={hideRowsPerPage}
            />
          </div>

          <div>
            <Modal open={openEditModal}>
              <GroupEdit
                updateOpenEditModal={updateOpenEditModal}
                openEditConfirm={openEditConfirm}
                updateOpenEditConfirm={updateOpenEditConfirm}
                editInput={detail}
                setDisplayGroupName={setGroupName}
                cityId={cityId}
                setCityId={setCityId}
              />
            </Modal>
          </div>
          <div>
            <Modal open={openGroupAdd}>
              <GroupAddAdmin
                openGroupAddConfirm={openGroupAddConfirm}
                updateOpenGroupAdd={updateOpenGroupAdd}
                updateOpenGroupAddConfirm={updateOpenGroupAddConfirm}
                cancelAction={groupCancelAction}
                backAction={groupBackAction}
                updateGroups={updateGroups}
                cityId={cityId}
                setCityId={setCityId}
              />
            </Modal>
          </div>
        </main>
        <ProgressDialog openProgress={openProgress} loading={loading} />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
